import { Alert, Button, Collapse, Divider, message, Modal, Space, Spin } from "antd";
import { PlusIcon } from "../../admin/Icons";
import Overlay from "../Overlay";
import wrap from "../../utils/wrap";
import { usePrefs } from "../../utils/Prefs";
import Save from "../Save";
import Colour from "./Colour";
import { useState } from "react";
import conditional from "../../utils/conditional";
import Gradient from "./Gradient";
import Font from "./Font";
import UploadFont from "./UploadFont";
import GoogleFontFetch from "./GoogleFontFetch";

export default function Fonts(props) {

    const [prefs, setPrefs] = usePrefs();
    const { templates = [], data = {}, setData = () => { }, changed = false, view = "" } = props;
    const { fonts = [] } = data;


    const _default_font = {
        name: "Default",
        path: "",
        is_import: false
    }

    // Save or Edit
    const save = (_data, _is_new = false) => {

        let _arr = [...fonts];

        if (_is_new) {
            _data.id = fonts.length + 1;
            _arr.push(_data);
            setData({ ...data, "fonts": _arr });
            setPrefs({ ...prefs, "changed": true });
            return;
        } else {
            let _index = _arr.findIndex(item => item.id == _data.id);
            if (_index > -1) {
                _arr[_index] = _data;
                setData({ ...data, "fonts": _arr });
                setPrefs({ ...prefs, "changed": true });
            } else {
                message.error("There was an error");
            }
        }
    }

    const reset = (_id) => {
        Modal.confirm({
            title: "Reset?",
            onOk: () => {
                let _fonts = [...fonts];
                let _f = _fonts.findIndex(item => item.id === _id);
                if (_f > -1) {
                    _fonts[_f] = { ..._default_font, "id": _id }
                } else {
                    message.error(<pre>{JSON.stringify(_fonts, null, 2)}</pre>)
                }
                setData({ ...data, "fonts": _fonts });
                setPrefs({ ...prefs, "changed": true });
            }
        })
    }

    const remove = (_id) => {

        Modal.confirm({
            title: "Delete?",
            onOk: () => {
                let _fonts = data.fonts.filter(item => item.id !== _id);
                setData({ ...data, "fonts": _fonts });
                setPrefs({ ...prefs, "changed": true });
            }
        })
    }



    const drawHeader = () => {
        return (
            <Overlay width="300px" component={<Font template={data} templates={templates} fonts={fonts} save={save} is_new />}><wrap.tags color="#1890ff"><PlusIcon /> <small>Select from uploaded</small></wrap.tags></Overlay>
        )
    }

    const drawColours = () => {
        return (
            <div>
                <Alert closable style={{ "lineHeight": "10px", "marginBottom" : "15px" }} description={<div style={{ "lineHeight": "14px" }}><small>The following fonts are activated and ready for use on your Webstore. <div className="shim" />Only activate extra fonts you plan on using, as more fonts can reduce site performance for customers. Classic "websafe" fonts along with previously uploaded fonts can be reactivated using the <strong>Select from uploaded button.</strong></small></div>} />
                {fonts.map(item => {
                    return <Font template={data} templates={templates} fonts={fonts} type="color" colours={fonts} key={item.id} changed={changed} save={save} reset={reset} remove={remove} data={item} />
                })}
                <Divider dashed style={{ "margin": "15px 0px" }} />
                <Space>
                <Overlay width={300} component={<UploadFont save={save} />}>
                    <Button style={{"width" : "128px"}}  size="small" block type="primary"><small>Upload Font File</small></Button>
                </Overlay>
                <Overlay width={300} component={<GoogleFontFetch save={save} />}>
                    <Button style={{"width" : "128px"}} size="small" block type="primary"><small>Add Google Font</small></Button>
                </Overlay>
                </Space>
            </div>
        )
    }

    switch (view) {
        case "header":
            return drawHeader();
        default:
            return drawColours();
    }

}

